import Accordion from 'react-bootstrap/Accordion';
import AvisArbitrage from './avisArbitrage';

function AncienMatchAffichage(props) {





  return (
    <>
    {props.equipe && (
        <>
            <Accordion defaultActiveKey="0">
            {props.equipe.AncienMatch && props.equipe.AncienMatch.map((item, index) => (
                      <Accordion.Item key={index}  eventKey={index}>
                                <Accordion.Header>
                                    <div className="text-center mb-3">
                                      {item.equipe_dom} {item.score === null ? ('-'):(item.score)} {item.equipe_ext}<br/> {item.date} <br/> {item.competition}
                                    </div>
                                  </Accordion.Header>
                        <Accordion.Body>
                        {props.equipe.arbitre && props.equipe.arbitre.filter(items => items.id_match === item.id_match && items.status === "accepter" && items.id_arbitre === props.userData.user.donnée.results[0].id).length !== 0 ? (
                                        props.equipe.arbitre
                                            .filter(items => items.id_match === item.id_match && items.id_arbitre === props.userData.user.donnée.results[0].id)
                                            .map((Item, index) => (
                                                <div key={index} className="cards-container">
                                                   <AvisArbitrage userData={props.userData} status={Item} avis={props.equipe.avis} match={item}/>
                                                </div>    
                                            ))
                                    ) : (
                                        <div className="text-center mb-3">
                                            <p>Aucune candidature retenue pour ce match.</p>
                                        </div>
                                    )}
                        </Accordion.Body>
                    </Accordion.Item>
            ))}
            </Accordion>
            <br/>
        </>
    )}

    </>
  );
}

export default AncienMatchAffichage;